import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionWastePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionWaste.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionWaste.button1'),
          value: 'minimal',
        },
        {
          text: t('pages.onboarding.questionWaste.button2'),
          value: 'some',
        },
        {
          text: t('pages.onboarding.questionWaste.button3'),
          value: 'moderate',
        },
        {
          text: t('pages.onboarding.questionWaste.button4'),
          value: 'significant',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
